/*
    Description: google translate
    Author URI: https://www.adillice.com
    Author: adillice
    Version: 1.0.0
*/
// clean up google translate dropdown
class Translate{

    // class constructor
    constructor({
        googleWrapperID = "google-translate",
        hideClass = "--js-hide"
    }={}){
        
        // get google element ID
        this.ID = googleWrapperID;

        // get google wrapper
        this.wrapper = document.querySelector(`#${this.ID}`);

        // hide class
        this.hide = hideClass;

        // run everything
        this.run();

    }

    // run code
    run(){

        // make sure we have both wrapper and google translate
        if(!window.google || !window.google.translate || !this.wrapper) return;

        // run setIn
        this.observe();

    }

    // scan for DOM element
    observe(){

        // config
        const config = {
            childList:true, 
            subtree:true
        };
        
        // callback
        const callback = (mutationsList, observer) => {
          
            const self = this;

            // LOOP: for loop
            for(const mutation of mutationsList){

                // check type
                if(mutation.type === "childList"){


                    // get logo
                    const logo = self.wrapper.querySelector("div > div > span")
                    
                    // check for logo 
                    if(logo){

                        // remove google logo image
                        logo.remove();

                        // remove text
                        self.wrapper.firstChild.firstChild.nextSibling.remove();

                        // remove hide class
                        self.wrapper.classList.remove(this.hide);

                        // Stop observing
                        observer.disconnect(); 
                        
                    }
                    
                }
                
            }
            
        };
        
        // set observer callback
        const observer = new MutationObserver(callback);
        
        // search for wrapper with config
        observer.observe(this.wrapper, config);

    }
       
}

// export module
export default Translate;